import * as React from 'react';

export const close = (): React.ReactElement => (
  <g>
    <path
      d="M9.78,8l5.85,5.85a1.26,1.26,0,0,1-1.78,1.78L8,9.78,2.15,15.63A1.26,1.26,0,0,1,.37,13.85L6.22,8,.37,2.15A1.26,1.26,0,0,1,2.15.37L8,6.22,13.85.37a1.26,1.26,0,0,1,1.78,1.78Z"
      style={{ fill: 'inherit' }}
    />
  </g>
);

export default close;
